export const TRANSLATION_KEYS = {
  fieldLabel: 'product-exhibits-distributor',
  inputLabel: 'partnerbasicinfo-exhibits-distributor',
}
